/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 메인페이지 지역 축제 소식 컴포넌트
 * 버전 : 1.0
 * 파일명 : Festival.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-12-30
 * ================================================================ 
 * 수정일 : 2026-02-04 : 데이터 연결
 * 수정일 : 2026-02-05 : 축제 소식 요소 클릭시 캘린더 화면으로 넘어가도록 변경
 * ================================================================ */

import { styled } from '@mui/material'
import { useState,useEffect } from 'react'
import { getDateDifference } from 'src/utils/DateUtils'
import { useStorageStore } from 'src/stores/StorageStore'
import { useNavigate } from 'react-router-dom'
import { getEventInfoFeature } from 'src/api/Recruit'
import { SessionWrapper } from 'src/utils/Etc'
import { useRecruitStore } from 'src/stores/RecruitStore'

const PageWrapper = styled('div')({
  margin: '0px 20px 10px 20px',
  borderRadius: '10px',
  backgroundColor: '#FFF',
  boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)',
  paddingBottom:'20px'
})

const TitleWrapper = styled('div')({
  display: 'flex',
  justifyContent:'space-between',
  alignItems:'center',

  fontWeight : '700',
  fontSize: '18px',
  padding:'20px',
  paddingBottom:'10px',
})

const ShowMoreSpan = styled('span')({
  fontSize:'14px',
  fontWeight: '400',
  textDecorationLine:'underline'
})

const ListWrapper = styled('div')({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  width:'100%',
  flexDirection:'column',
  padding:'0px 20px',
  gap:'8px'
})

const ListContainer = styled('div')({
  display:'flex',
  justifyContent:'space-between',
  alignItems:'center',
  backgroundImage: 'linear-gradient(180deg, #F9F9F9 0%, #F3F3F3 100%)',
  width:'100%',
  padding:'10px',
  borderRadius:'5px'
})

const LeftGroup = styled('div')({
  display: 'flex',
  gap: '10px', // TypeWrapper와 NameWrapper 간 간격
  alignItems: 'center',
});

const NameWrapper = styled('div')({
  display:'flex',
  marginRight:'auto',
  marginLeft:0
})

const DateWrapper = styled('div')({
  display:'flex',
  marginLeft:'auto',
  fontSize:'12px',
  opacity:0.5
})

const Festival = () => {
  const [top3,setTop3] = useState<any[]>([])
  const getUserdata = useStorageStore().getItem('user').data.user_area
  const navigate = useNavigate();
  const setField = useRecruitStore((state)=>state.setField)

  useEffect(() => {
    const fetchTop3 = async () => {
      try {
        const response = await getEventInfoFeature();
        setTop3(response.data); // 받아온 데이터를 상태에 저장
      } catch (error) {
        console.error('축제정보 불러오기 실패:', error);
      }
    };

    fetchTop3();
  }, []); // 컴포넌트 mount 시 한 번 실행

  const onClickShowMore = ()=>{
    setField('dialogState','축제 정보')
    navigate('/recruitment')
  }

  const calcDday = (day:number)=>{
    if(day === 0) return 'D-day'
    if(day > 0) return `D+${day}`
    if(day < 0) return `D${day}`
  }

  const onClickToRecruit = (data: any) => {
    const convertedEvent = {
      title: data.event_name,
      start: new Date(data.start_date),
      end: new Date(data.end_date),
      announce_id: data.event_id,
      course_name: data.event_name,
      course_status: data.course_status,
      wide_loc: data.wide_loc,
      city_loc: data.city_loc,
      address: data.address,
      latitude: data.latitude,
      longitude: data.longitude,
      description: data.description,
      urlLink: data.url,
      recruitment_type: data.event_type === "축제" ? "축제" : "박람회",
    };

    setField('dialogData', [convertedEvent]);
    setField('dialogCurrentDate',data.start_date)
    setField("isOpen", true);
    setField("dialogState", "축제 정보");
    navigate("/recruitment");
  };

  return (
    <PageWrapper>
      <TitleWrapper>
        지역 축제 소식
        {Object.keys(getUserdata).length !== 0 &&
        <ShowMoreSpan onClick={onClickShowMore}>
          더보기
        </ShowMoreSpan>
        }
      </TitleWrapper>
      <ListWrapper>
        {top3?.map((item:any, index:number) => (
          <ListContainer key={index} onClick={()=>onClickToRecruit(item)}>
            <LeftGroup>
              <SessionWrapper session={item.event_type} >{item.event_type}</SessionWrapper>
              <NameWrapper>{item.event_name}</NameWrapper>
            </LeftGroup>
            <DateWrapper>{calcDday(Math.min(getDateDifference(item.start_date), 999))}</DateWrapper>
          </ListContainer>
        ))}
      </ListWrapper>
    </PageWrapper>
  )
}

export default Festival